import { Stack } from '@mui/material';

interface UploadingDocumentsScreenProps {
    /** Everything the overlay shows. Centred and gap-spaced by the container. */
    readonly content: React.ReactNode;
    /**
     * Accessible name for the region. A caller whose `content` says something more specific should
     * say the same thing here, or the announced and visible text disagree.
     */
    readonly label?: string;
}

export default function UploadingDocumentsScreen({
    content,
    label = 'Uploading documents',
}: Readonly<UploadingDocumentsScreenProps>) {
    return (
        <Stack
            // A live region, not just a labelled box: without a role this announced nothing at all,
            // so an upload began and finished in silence. `polite` because the member started it.
            role="status"
            aria-live="polite"
            aria-label={label}
            gap={2}
            alignItems="center"
            justifyContent="center"
            // Shares one grid cell with the drop zone it covers, so this content sets the height of
            // the box when it is the taller of the two. See the grid on `DragAndDrop`'s `Paper`.
            sx={{
                gridArea: 'content',
            }}>
            {content}
        </Stack>
    );
}
